import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=293010d4&scoped=true&lang=pug&"
import script from "./BreadCrumb.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumb.vue?vue&type=script&lang=ts&"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=293010d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293010d4",
  null
  
)

export default component.exports